import Vue from "vue";
import { store } from "../store/store.js";
import Router from "vue-router";
// const EditProfile = () => import('@/views/Auth/EditProfile');

import LoginPage from "@/views/Auth/Login";
import Dashboard from "@/views/Dashboard";
import PageNotFound from "@/views/Error/PageNotFound";

Vue.use(Router);

const router = new Router({
	mode: "history",
	base: process.env.BASE_URL,
	routes: [
		//Login Path
		{
			path: "/",
			redirect: "/login",
		},
		{
			path: "/login",
			name: "Login",
			component: LoginPage,
			meta: {
				requiresAuth: false,
			},
		},

		//Dashboard
		// {
		//   path : '/home',
		//   name : 'Home',
		//   component : Dashboard,
		//   meta : {
		//     requiresAuth : true
		//   }
		// },
		// {
		//   path : '/about',
		//   name : 'About',
		//   component : Dashboard,
		//   meta : {
		//     requiresAuth : true
		//   }
		// },

		// [SPECIAL] User Color
		{
			path: "/work-order-listing",
			name: "WorkOrderListing",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/work-order-color/:id",
			name: "ColorDetail",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},

		// Alternative Landing Page
		{
			path: "/welcome",
			name: "Welcome",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},

		// Dashboard - Work Order Form
		{
			path: "/home",
			name: "Homepage",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},

		// Dashboard - Work Order Form
		{
			path: "/work-order-form",
			name: "WorkOrderForm",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/work-order-form/scan",
			name: "Scanner",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/work-order-step",
			name: "WorkOrderFormStep",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/work-order-form/new",
			name: "WorkOrderFormNew",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/work-order-detail/edit/data/:form_code",
			name: "InsertCarData",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/work-order-detail/insert/image/:form_code",
			name: "InsertCarImage",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/work-order-detail/edit/:work_order_code",
			name: "EditWorkOrder",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/work-order-detail/v2",
			redirect: { name: "WorkOrderDetailV2", params: { type: "wo" } },
		},
		{
			path: "/work-order-detail/:type",
			name: "WorkOrderDetailV2",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/work-order-detail/v2/:type",
			name: "WorkOrderDetailV2",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/work-order/check/:type/:form_code",
			name: "exitCheck",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/work-order/check/v2/:type/:form_code",
			name: "exitCheckV2",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},

		// CSO
		{
			path: "/cso/exit-permit",
			name: "CSOExitPermit",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/cso/insurance-policy",
			name: "CSOInsurancePolicy",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/customer-quotation",
			name: "CSOCustomerQuotationView",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/customer-quotation/create",
			name: "CSOCustomerQuotationCreate",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/customer-quotation/create/v2",
			name: "CSOCustomerQuotationCreateV2",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/customer-quotation/edit/:form_code",
			name: "CSOCustomerQuotationEdit",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/setting/master-data/color",
			name: "CSOMasterColor",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/setting/master-data/brand-&-type",
			name: "CSOMasterBrandAndType",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/setting/master-data/brand-&-type",
			name: "CSOMasterBrandAndType",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/setting/master-data/brand-&-type/add",
			name: "CSOMasterAddBrandAndType",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/setting/master-data/customer",
			name: "CSOMasterCustomer",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/setting/master-data/customer-car",
			name: "CSOMasterCustomerCar",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		
		{
			path: "/setting/master-data/supplier",
			name: "CSOMasterSupplier",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/setting/master-data/cat-brand",
			name: "CSOMasterCatBrand",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/setting/master-data/supply-apply",
			name: "CSOSupplyApply",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},

		// Estimator

		{
			path: "/setting/master-data/master-insurance",
			name: "EstimatorMasterInsurance",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/setting/master-data/master-insurance/pricelist/:id",
			name: "EstimatorInsurancePriceList",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/estimator/estimator-application/tambah-sparepart",
			name: "EstimatorAddSparepart",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/estimator/estimator-application/:id",
			name: "EstimatorApplication",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/estimator/estimator-parts/:id",
			name: "EstimatorParts",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/inventory/sparepart-estimations",
			name: "EstimatorSparepart",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/inventory/sparepart-estimations/:id",
			name: "EstimatorSparepartDetail",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/cso/complain-work-order",
			name: "ComplainWorkOrder",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/estimator/complain-work-order/:id",
			name: "ComplainView",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},

		// Inventory
		{
			path: "/setting/master-data/master-sparepart",
			name: "MasterSparepart",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/inventory/inventory-usage",
			name: "InventoryUsage",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/inventory/sparepart-purchasing",
			name: "PurchaseInventoryList",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/inventory/sparepart-purchasing/:workOrderCode",
			name: "PurchaseInventory",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/inventory/salvage-parts",
			name: "SalvageParts",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/inventory/salvage-parts/:form_code/:insurance_company",
			name: "SalvagePartsDetail",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/inventory/sparepart-purchasing-stock",
			name: "PurchaseStock",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/inventory/pending-sparepart",
			name: "PendingSparepart",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},

		// Report
		
		{
			path: "/finance/supplier-voucher/:data",
			name: "SupplierVoucherDetails",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/report/insurance-report",
			name: "ReportInsurance",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/report/policy-expiry",
			name: "ReportInsurancePolicyExpiry",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/finance/petty-cash",
			name: "PettyCash",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/report/own-risk",
			name: "OwnRisk",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/report/inventory-usage",
			name: "ReportInventoryUsage",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/report/po-sparepart",
			name: "POSparepart",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/finance/revenue",
			name: "ReportRevenue",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/report/outstanding-estimation",
			name: "OutstandingEstimation",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/report/outstanding-estimation-sparepart",
			name: "OutstandingEstimationSparepart",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},

		{
			path : '/report/estimation-same-day',
			name : 'EstimationSameDay',
			component : Dashboard,
			meta : {
				requiresAuth : true
			}
		},

		{
			path : '/report/not-being-worked-on',
			name : 'NotBeingWorkedOn',
			component : Dashboard,
			meta : {
				requiresAuth : true
			}
		},
		{
			path: "/report/price-evaluation",
			name: "PriceEvaluation",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/report/supplier-report",
			name: "SupplierReport",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/report/idle-report",
			name: "IdleReport",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},

		// Finance
		// {
		// 	path: "/finance/petty-cash",
		// 	name: "FinanceKasKecil",
		// 	component: Dashboard,
		// 	meta: {
		// 		requiresAuth: true,
		// 	},
		// },
		{
			path: "/finance/down-payment",
			name: "FinanceDownPayment",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/finance/supplier-voucher",
			name: "SupplierVoucher",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/finance/supplier-voucher/create",
			name: "SupplierVoucherCreate",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/finance/payments",
			name: "FinancePayment",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/finance/account-transaction",
			name: "FinanceAccountTransaction",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/finance/paycheck",
			name: "FinancePaycheck",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/finance/kwitansi-history",
			name: "FinanceKwitansiHistory",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/finance/paycheck-monthly",
			name: "FinancePaycheckMonthly",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/finance/work-order-payment",
			name: "FinanceWorkOrderPayment",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/finance/income-statement",
			name: "FinanceIncomeStatement",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/finance/balance-sheet",
			name: "FinanceBalanceSheet",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/finance/jasa-borongan",
			name: "FinanceJasaBorongan",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},

		// Human Resource

		{
			path: "/human-resource/absence",
			name: "HumanResourceAttendance",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/human-resource/kpi",
			name: "HumanResourceKpi",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/human-resource/laborer",
			name: "CSOMasterLaborer",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},

		// Settings
		{
			path: "/setting/user-management",
			name: "UserManagement",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/setting/role-management",
			name: "RoleManagement",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/setting/price-list",
			name: "PriceListOption",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/setting/company-detail",
			name: "CompanyDetail",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/setting/checklist-work-order-items",
			name: "ChecklistItems",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/setting/part-services",
			name: "PartServices",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/setting/admin-authorization",
			name: "AdminAuthorization",
			component: Dashboard,
			meta: {
				requiresAuth: true,
			},
		},

		//Error 404 Page Not Found
		{
			path: "*",
			component: PageNotFound,
			meta: {
				requiresAuth: false,
			},
		},
	]
});

export default router;
